export function getBlankRecord() {
  return {
    id: null,
    name: null,
    prismsName: null,
    permissions: []
  };
}
